export const lower = (str) => str.toLowerCase()
export const clone = (data) => JSON.parse(JSON.stringify(data))
export const round = (number, decimalPoints = 2) =>
  Number(Number.parseFloat(number).toFixed(decimalPoints))

export { default as generateEmail } from './generateEmail'
export { default as debounce } from './debounce'
export { default as priceCalculator } from './priceCalculator'
export { default as getItemKind } from './getItemKind'
